import { createRoot } from 'react-dom/client';
import {Provider} from "react-redux";
import {SnackbarsStack} from "../react_components/snackbarsStack";
import React from "react";

App.Views.SnackbarStackView = App.Views.BaseView.extend({
    initialize: function (options) {
        this.root = createRoot(this.el);
        this.store = options.store;
    },

    render: function () {
        this.root.render(
            <Provider store={this.store}>
                <SnackbarsStack />
            </Provider>
        );
        return this;
    },

    remove: function () {
        this.root.unmount();
        Backbone.View.prototype.remove.call(this);
    }

});

export default App.Views.SnackbarStackView;
